import { memo } from 'react';
import VideoPlayer from '@components/Video/VideoPlayer';
import styles from '@components/ProductCardNew/ProductImage/PackshotVideo/PackshotVideo.styles';
type PropsType = {
  url: string;
  poster?: string;
  onLoadFunc?: () => void;
  onErrorFunc?: () => void;
  isHover?: boolean;
};
const PackshotVideo = memo(({
  url,
  poster = '',
  onLoadFunc,
  onErrorFunc,
  isHover = false
}: PropsType) => {
  if (!url || url === '') {
    if (onErrorFunc) onErrorFunc();
    return null;
  }
  return <div sx={styles.videoContainer(isHover)} className={isHover ? 'hoverImage' : ''}>
      <VideoPlayer video={url} playVideo poster={poster} loop onLoaded={onLoadFunc} onErrorFunc={onErrorFunc} />
    </div>;
});
PackshotVideo.displayName = 'PackshotVideo';
export default PackshotVideo;